<ion-header>
  <ion-toolbar>
    <ion-title>Share</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="onSendClick()">Send</ion-button>
      <ion-button fill="clear" (click)="onCancelClick()">Cancel</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="smartdine-form">

    <!-- Email Input -->
    <ion-item lines="none" class="ion-inset">
      <ion-label>Emails:</ion-label>
      <ion-input
        type="text"
        [(ngModel)]="toEmailIds"
        placeholder="Enter emails"
      ></ion-input>
    </ion-item>
    <small class="error-text" *ngIf="emailError">{{ emailError }}</small>

    <!-- Country Code + Phone Input -->
    <ion-item lines="none" class="ion-inset d-flex justify-content-between">
      <ion-label>Mobile:</ion-label>
      
      <div class="d-flex">
        <ion-select
          interface="popover"
          [(ngModel)]="selectedCountryCode"
          style="max-width: 90px"
        >
          <ion-select-option value="+91">🇮🇳 +91</ion-select-option>
          <ion-select-option value="+1">🇺🇸 +1</ion-select-option>
        </ion-select>
  
        <ion-input
          type="text"
          [(ngModel)]="toPhoneNumbers"
          placeholder="Comma-separated numbers"
        ></ion-input>
      </div>
    </ion-item>
    <small class="error-text" *ngIf="phoneError">{{ phoneError }}</small>

  </div>
</ion-content>
